import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type ResettableBooleanState = boolean | "";
type SliderClickState = boolean | { sliderClick: boolean };
type TextState = string | number | boolean;

/**
 * AloAocStateService
 * --------------------------------------------------------------------
 * ALO / AOC / Startup / PSU-enable / Lumin coordination streams.
 */
@Injectable({ providedIn: "root" })
export class AloAocStateService {
  // --- ALO ---------------------------------------------------------
  readonly aloValidData = new BehaviorSubject<ResettableBooleanState>(false);
  readonly checkALOGraph: Observable<ResettableBooleanState> = this.aloValidData.asObservable();
  readonly aloPercent = new BehaviorSubject<TextState>("");
  readonly quickAloPercent = new BehaviorSubject<TextState>("");
  readonly quickConfig = new BehaviorSubject<TextState>("");
  readonly getquickConfig: Observable<TextState> = this.quickConfig.asObservable();
  readonly setAloQuick = new BehaviorSubject<TextState>("");
  readonly getQuickAlo: Observable<TextState> = this.setAloQuick.asObservable();
  readonly enableAlo = new BehaviorSubject<boolean>(false);

  // --- AOC ---------------------------------------------------------
  readonly isAOCValid = new BehaviorSubject<TextState>("");
  readonly onSliderClick = new BehaviorSubject<SliderClickState>(false);
  readonly aocSliderCick: Observable<SliderClickState> = this.onSliderClick.asObservable();
  readonly aocValue = new BehaviorSubject<TextState>("");
  readonly getAocValue: Observable<TextState> = this.aocValue.asObservable();
  readonly aocEdited = new BehaviorSubject<boolean>(false);

  // --- Startup Slider ---------------------------------------------
  readonly startupSlider = new BehaviorSubject<TextState>("");
  readonly startupSliderClick: Observable<TextState> = this.startupSlider.asObservable();
  readonly isStartupValueValid = new BehaviorSubject<TextState>("");
  readonly checkStartupIsValid: Observable<TextState> = this.isStartupValueValid.asObservable();
  readonly isStartupEditedValue = new BehaviorSubject<boolean>(false);

  // --- PSU enable flags -------------------------------------------
  readonly enablePSU = new BehaviorSubject<ResettableBooleanState>(false);
  readonly checkPSUenable: Observable<ResettableBooleanState> = this.enablePSU.asObservable();
  readonly enableHBPSU = new BehaviorSubject<ResettableBooleanState>(false);
  readonly checkHBPSUenable: Observable<ResettableBooleanState> = this.enableHBPSU.asObservable();
  readonly enableLGPSU = new BehaviorSubject<ResettableBooleanState>(false);
  readonly checkLGPSUenable: Observable<ResettableBooleanState> = this.enableLGPSU.asObservable();

  // --- Lumin -------------------------------------------------------
  readonly luminValue = new BehaviorSubject<TextState>("");
  readonly getLuminValue: Observable<TextState> = this.luminValue.asObservable();
  readonly luminError = new BehaviorSubject<ResettableBooleanState>(false);
  readonly getLuminFormError: Observable<ResettableBooleanState> = this.luminError.asObservable();
  readonly luminValueEdited = new BehaviorSubject<boolean>(false);
  readonly getLuminValueEdited: Observable<boolean> = this.luminValueEdited.asObservable();

  // --- Setters ----------------------------------------------------
  aloSetErrorButton(data: ResettableBooleanState): void {
    this.aloValidData.next(data);
  }
  aloPercentConfigurationData(data: TextState): void {
    this.aloPercent.next(data);
  }
  quickAloPercentConfigurationData(data: TextState): void {
    this.quickAloPercent.next(data);
  }
  sendQuickConfig(data: TextState): void {
    this.quickConfig.next(data);
  }
  setAloData(data: TextState): void {
    this.setAloQuick.next(data);
  }
  sentAloEnabled(data: boolean): void {
    this.enableAlo.next(data);
  }

  sendAOCValidData(data: TextState): void {
    this.isAOCValid.next(data);
  }
  aocSliderClickEvent(data: SliderClickState): void {
    this.onSliderClick.next(data);
  }
  aocValueChange(data: TextState): void {
    this.aocValue.next(data);
  }
  isEdited(data: boolean): void {
    this.aocEdited.next(data);
  }

  startupSliderClickEvent(data: TextState): void {
    this.startupSlider.next(data);
  }
  sendStartupValidData(data: TextState): void {
    this.isStartupValueValid.next(data);
  }
  isStartupEdited(data: boolean): void {
    this.isStartupEditedValue.next(data);
  }

  sentPSUEnable(data: ResettableBooleanState): void {
    this.enablePSU.next(data);
  }
  sentHBPSUEnable(data: ResettableBooleanState): void {
    this.enableHBPSU.next(data);
  }
  sentLGPSUEnable(data: ResettableBooleanState): void {
    this.enableLGPSU.next(data);
  }

  setLuminValue(data: TextState): void {
    this.luminValue.next(data);
  }
  setLuminFormInputValidation(data: ResettableBooleanState): void {
    this.luminError.next(data);
  }
  setLuminValueChanges(data: boolean): void {
    this.luminValueEdited.next(data);
  }
}
